import tmhRequest from '@/config/tmhRequest'

export default {
    searchListCustomerTagsInfoForGroup: function (data) {
        return tmhRequest({
            url: '/customer/customertagsinfo/searchlistcustomertagsinfoforgroup',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/customer/customertagsinfo.js